<template>
  <div class="helmet_box animate__animated animate__fadeIn">
    <div class="helmet">
      <!-- 安全帽详情 -->
      <div class="content_box">
        <!-- <div class="content_title">AI监测</div> -->
        <div class="content">
          <div class="content_tab">
            <div class="img_box">
              <div class="content_img" v-for="(item, index) in HelmetList" :key="index" @click="fnGetBigImg(item)">
                <img :src="item.img" />
                <div class="img_title">
                  <div class="title_line">类型: {{ item.type }}</div>
                  <div class="title_line">抓拍时间: {{ item.capture_at }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="cont_pages">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            :current-page="currentPage"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          />
        </div>
      </div>
      <div class="data_list">
        <div class="title">AI监测({{ HelmetData.length }}台)</div>
        <div class="list_title">
          <div class="title_item">设备编号</div>
          <div class="title_item">在线状态</div>
        </div>
        <div class="list_box">
          <div v-if="HelmetData">
            <div class="box_line" v-for="(item, index) in HelmetData" :key="item.id" @click="fnHelmetToggle(item, index)" :class="currentHelmetIndex == index ? 'active' : ''">
              <div class="line_item">{{ item.number }}</div>
              <div class="line_item">{{ fnOnlineStatusText(item.heartbeat).text }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="dialog_img animate__animated animate__fadeIn" v-if="showImgWin">
        <el-dialog :modal="false" title="查看图片" center :visible.sync="showImgWin">
          <div class="content_detail"><img :src="bigImg" /></div>
          <div slot="footer" class="dialog-footer">
            <div class="btn_line">
              <div class="search-btn red" @click="showImgWin = false"><span>关闭</span></div>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
import APP from '@/utils/base';
import { getEqptInfo, removeEqptInfo } from '@/utils/auth';
export default {
  data() {
    return {
      pageSize: 12,
      pageSizes: [12, 20, 50, 100, 500, 1000],
      currentPage: APP.PAGE.SKIP_PAGE,
      helmetNumber: null,
      pageTotal: 0,
      currentHelmetIndex: 0, // 右侧列表选项
      HelmetData: [], // 右侧安全帽列表
      selectData: [], // 当前显示的数据
      HelmetList: [], // 当前安全帽列表数据
      showImgWin: false,
      bigImg: '',
      isIndex: false,
      indexMsg: null
    };
  },
  created() {
    let _msg = getEqptInfo();
    if (_msg && _msg.pointType == 'AI监测') {
      this.isIndex = true;
      this.indexMsg = _msg.pointNumber;
    }
    this.fnGetHelmetData();
  },
  beforeDestroy() {
    removeEqptInfo();
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.fnGetHelmetList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fnGetHelmetList();
    },
    // 获取安全帽设备列表
    fnGetHelmetData() {
      request({
        url: 'project/helmet/numbers',
        method: 'GET'
      })
        .then(res => {
          let _data = res.data;
          this.HelmetData = _data;
          if (this.isIndex) {
            for (let i in _data) {
              if (this.indexMsg == _data[i].number) {
                this.currentHelmetIndex = i;
                this.helmetNumber = this.indexMsg;
                this.fnGetHelmetList();
              }
            }
          } else {
            this.helmetNumber = this.HelmetData[0] ? this.HelmetData[0].number : '';
            this.fnGetHelmetList();
          }
        })
        .catch(err => {
          this.$message.error(err.data);
        });
    },
    // 安全帽在线状态
    fnOnlineStatusText(_heartbeatTime) {
      return APP.fnOnlineStatusText(_heartbeatTime);
    },
    // 获取当前安全帽的详情列表
    fnGetHelmetList() {
      let _number = this.helmetNumber;
      if (_number) {
        request({
          url: 'project/helmet/details',
          method: 'GET',
          params: {
            page: this.currentPage,
            size: this.pageSize,
            number: _number
          }
        })
          .then(res => {
            let _data = res.data.list;
            this.HelmetList = _data;
            this.pageTotal = res.data.count;
          })
          .catch(err => {
            this.$message.error(err.data);
          });
      }
    },
    // 查看大图
    fnGetBigImg(item) {
      this.bigImg = item.img;
      this.showImgWin = true;
    },
    // 切换右侧设备号
    fnHelmetToggle(item, index) {
      this.currentHelmetIndex = index;
      this.helmetNumber = item.number;
      this.fnGetHelmetList();
    }
  }
};
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.helmet_box {
  width: 1920px;
  height: 858px;
  position: relative;
  overflow: hidden;
  .helmet {
    position: absolute;
    left: 0;
    right: -20px;
    top: 0;
    bottom: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }
}
.content_box {
  position: relative;
  overflow: hidden;
  width: 1580px;
  height: 848px;
  margin: 10px 0 0 20px;
  .content_title {
    width: 1580px;
    height: 50px;
    line-height: 50px;
    font-size: 26px;
    text-align: center;
  }
  .content {
    width: 1580px;
    height: 730px;
    position: relative;
    overflow: hidden;
    background-color: rgba(29, 68, 149, 0.1);
    .content_tab {
      position: absolute;
      left: 0;
      right: -30px;
      top: 0;
      bottom: 0;
      overflow-x: hidden;
      overflow-y: auto;
      .img_box {
        width: 1580px;
        height: 730px;
        .content_img {
          width: 380px;
          height: 320px;
          float: left;
          margin: 20px 20px 20px 0;
          &:nth-child(4n) {
            margin-right: 0;
          }
          img {
            width: 380px;
            height: 240px;
          }
          .img_title {
            width: 380px;
            height: 80px;
            background-color: rgba(0, 255, 255, 0.1);
            .title_line {
              padding: 0 10px;
              width: 380px;
              height: 40px;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
  .cont_pages {
    width: 1580px;
    height: 68px;
    @include flex-box(flex-start, center);
    >>> .el-pagination__total {
      color: #439fe3;
      font-size: 14px !important;
    }
    >>> .el-input__inner {
      background-color: rgba(49, 88, 128, 0.5) !important;
      border: none !important;
      color: #439fe3 !important;
    }
    >>> .el-pagination__jump {
      color: #439fe3;
      font-size: 14px !important;
    }
    >>> .el-select__caret {
      color: #439fe3;
    }
    >>> .el-pagination.is-background .btn-prev {
      color: #439fe3;
      background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-prev:disabled {
      color: #439fe3;
      background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-next {
      color: #439fe3;
      background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .btn-next:disabled {
      color: #439fe3;
      background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .el-pager li {
      color: #439fe3;
      background-color: rgba(49, 88, 128, 0.5) !important;
    }
    >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #50aaff !important;
      color: #091027;
    }
  }
}
.data_list {
  position: absolute;
  top: 0;
  left: 1620px;
  width: 300px;
  height: 848px;
  margin-top: 10px;
  background-color: rgba(29, 68, 149, 0.1);
  .title {
    width: 300px;
    height: 60px;
    font-size: 24px;
    background: url(../../../assets/img/per_list_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(center, center);
  }
  .list_title {
    width: 300px;
    height: 48px;
    background: url(../../../assets/img/enter_left_bg.png) no-repeat;
    background-size: 100% 100%;
    @include flex-box(flex-start, center);
    .title_item {
      width: 96px;
      margin: 0 2px;
      text-align: center;
      &:nth-child(1) {
        width: 196px;
      }
    }
  }
  .list_box {
    width: 300px;
    height: 740px;
    .box_line {
      width: 300px;
      height: 48px;
      cursor: pointer;
      border-bottom: 1px dashed #1d4495;
      @include flex-box(center, center);
      &:hover {
        background-color: rgba(49, 88, 128, 0.4);
      }
      .line_item {
        width: 96px;
        margin: 0 2px;
        text-align: center;
        &:nth-child(1) {
          width: 196px;
        }
      }
    }
  }
}

.dialog_img {
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    width: 750px;
    height: 600px;
    margin-top: 20vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-dialog__body {
    padding: 10px;
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  .content_detail {
    width: 100%;
    height: 460px;
    color: #ffffff;
    border: 1px solid rgba(58, 116, 221, 0.5);
    border-radius: 5px;
    overflow: hidden;
    img {
      width: 100%;
      height: 460px;
    }
  }
}
.active{
	color: #0080FF;
}
</style>



// WEBPACK FOOTER //
// src/views/Helmet/helmetDefault/index.vue